import { toast } from "react-toastify";
import { GET, POST } from "../Network/snpaxios";
import { CartOperation, OfferType, Server_Constants, WEBSITE_SHOP_HASH } from "./constant";
import { encode, getAddressUtils, isEmpty, printDebugLog } from "./utils";

const isProductInCart = (cart, id) => {
  return cart?.find((cartProduct) => cartProduct === id) ? true : false;
};

const updateTotalBasedOnCoupon = (orderState, couponInput, kOfferType, kOfferamt, orderDispatch) => {
  const { totalOfferApplied, totalBeforeOffer, offerAmt } = orderState;
  let parseTotalOfferApplied = totalOfferApplied;
  let mainGrandTotal = totalBeforeOffer;
  switch (parseInt(kOfferType)) {
    case OfferType.Flat:
      parseTotalOfferApplied += kOfferamt;
      mainGrandTotal = mainGrandTotal - kOfferamt;
      break;
    case OfferType.Percentage:
      parseTotalOfferApplied += (mainGrandTotal * kOfferamt) / 100;
      mainGrandTotal = mainGrandTotal - (mainGrandTotal * kOfferamt) / 100;
      break;
    default:
      parseTotalOfferApplied = parseTotalOfferApplied - offerAmt;
      break;
  }
  const mRoundOff = mainGrandTotal.toFixed() - mainGrandTotal;
  mainGrandTotal = mainGrandTotal + mRoundOff;
  orderDispatch({
    type: "setCouponData", payload: {
      coupon: couponInput, offerType: kOfferType,
      offerAmt: offerAmt,
      totalOfferApplied: parseTotalOfferApplied, total: mainGrandTotal,
    }
  });
}

const doTotal = (item, oItem, isAdd, orderState, orderDispatch) => {
  const { subTotal, totalOfferApplied, cgstAmt, sgstAmt, totalBeforeOffer, totalQuantity
    , offerDenom, offerAmt
  } = orderState;
  printDebugLog("doTotal", item, oItem, isAdd, orderState);
  if (isAdd) {
    const parseSubTotal = Number(subTotal) + Number(item.subTotalPrice) - Number(oItem?.subTotalPrice ?? 0.0);
    const parseTotalQuantity = Number(totalQuantity) + Number(item.quantity) - Number(oItem?.quantity ?? 0);
    const parseCgstAmt = Number(cgstAmt) + Number(item.cgstAmt) - Number(oItem?.cgstAmt ?? 0.0);
    const parsedSgstAmt = Number(sgstAmt) + Number(item.sgstAmt) - Number(oItem?.sgstAmt ?? 0.0);
    const parseTotalOfferApplied = Number(totalOfferApplied) + Number(item.appliedOfferAmt) - Number(oItem?.appliedOfferAmt ?? 0.0);
    const parseBeforeCouponTotal = Number(totalBeforeOffer) + Number(item.finalPrice) - Number(oItem?.finalPrice ?? 0.0);
    let mainGrandTotal = parseBeforeCouponTotal;
    switch (parseInt(offerDenom)) {
      case OfferType.Flat:
        mainGrandTotal = mainGrandTotal - offerAmt;
        break;
      case OfferType.Percentage:
        mainGrandTotal = mainGrandTotal - (mainGrandTotal * offerAmt) / 100;
        break;
      default:
        break;
    }
    const mRoundOff = mainGrandTotal.toFixed() - mainGrandTotal;
    mainGrandTotal = mainGrandTotal + mRoundOff;
    const orderObject = {
      totalQuantity: parseTotalQuantity,
      subTotal: parseSubTotal,
      cgstAmt: parseCgstAmt,
      sgstAmt: parsedSgstAmt,
      totalOfferApplied: parseTotalOfferApplied,
      totalBeforeOffer: parseBeforeCouponTotal,
      total: mainGrandTotal,
      orderAddress: orderState.orderAddress,
      offerDenom: offerDenom,
      offerAmt: offerAmt,
      coupon: orderState.coupon,
      roundOff: mRoundOff,
      isGstAllowed: orderState.isGstAllowed,
      deliveryCharge: orderState.deliveryCharge,
    };
    orderDispatch({ type: "setOrderDetails", payload: orderObject });
  } else {
    const parseSubTotal = Number(subTotal) - Number(oItem?.subTotalPrice ?? 0.0) + Number(item?.subTotalPrice ?? 0);
    const parseTotalQuantity = Number(totalQuantity) + Number(item?.quantity ?? 0) - Number(oItem?.quantity ?? 0);
    const parseCgstAmt = Number(cgstAmt) + Number(item?.cgstAmt ?? 0) - Number(oItem?.cgstAmt ?? 0.0);
    const parsedSgstAmt = Number(sgstAmt) + Number(item?.sgstAmt ?? 0) - Number(oItem?.sgstAmt ?? 0.0);
    const parseTotalOfferApplied = Number(totalOfferApplied) + Number(item?.appliedOfferAmt ?? 0) - Number(oItem?.appliedOfferAmt ?? 0.0);
    const parseBeforeCouponTotal = Number(totalBeforeOffer) + Number(item?.finalPrice ?? 0) - Number(oItem?.finalPrice ?? 0.0);
    let mainGrandTotal = parseBeforeCouponTotal;
    switch (parseInt(offerDenom)) {
      case OfferType.Flat:
        mainGrandTotal = mainGrandTotal - offerAmt;
        break;
      case OfferType.Percentage:
        mainGrandTotal = mainGrandTotal - (mainGrandTotal * offerAmt) / 100;
        break;
      default:
        break;
    }
    const mRoundOff = mainGrandTotal.toFixed() - mainGrandTotal;
    mainGrandTotal = mainGrandTotal + mRoundOff;
    const orderObject = {
      totalQuantity: parseTotalQuantity,
      subTotal: parseSubTotal,
      cgstAmt: parseCgstAmt,
      sgstAmt: parsedSgstAmt,
      totalOfferApplied: parseTotalOfferApplied,
      totalBeforeOffer: parseBeforeCouponTotal,
      total: mainGrandTotal,
      orderAddress: orderState.orderAddress,
      offerDenom: offerDenom,
      offerAmt: offerAmt,
      coupon: orderState.coupon,
      roundOff: mRoundOff,
      isGstAllowed: orderState.isGstAllowed,
      deliveryCharge: orderState.deliveryCharge,
    };
    orderDispatch({ type: "setOrderDetails", payload: orderObject });
  }
}

const buildCartItem = (item, carts = []) => {
  const columnLastItemIndex = carts[carts.length - 1]?.itemIndex ?? -1;
  const mItemIndex = columnLastItemIndex + 1;
  const price = item.bigPrice.productmrPrice;
  const finalSp = item.bigPrice.productSellingPrice;
  const appliedOfferAmt = parseFloat(price) - parseFloat(finalSp);
  const stockRefMap = new Map();
  stockRefMap.set(item.stockRefNo, item.unitName + "=" + 1);
  const jsonMapString = Object.fromEntries(stockRefMap);
  printDebugLog("buildCartItem ", carts.length, columnLastItemIndex, mItemIndex);
  return {
    itemIndex: mItemIndex,
    name: item.name,
    firstImage: item.firstImage,
    prdId: item.prdId,
    unit: item.unitName, //need to change TODO
    quantity: 1,
    price: price,
    subTotalPrice: price, // its mrp * quan
    finalPrice: finalSp, // its sp * quan
    decimalSmRestrictions: item.decimalSmRestrictions,
    choosePrices: 2/*Stock_Prices*/,
    stockRefNo: jsonMapString,
    lastStockRefNo: item.stockRefNo,
    hsn: item.hsn,
    listBatch: isEmpty(item.batchNo) ? [] : [item.batchNo],
    listBarCode: isEmpty(item.barCode) ? [] : [item.barCode],
    offerDenom: item.bigPrice.offerDenom,
    offerAmt: item.bigPrice.offerAmt,
    combo: false,
    cgst: item.custGstDisabled ? 0.0 : item.bigPrice.cgst,
    sgst: item.custGstDisabled ? 0.0 : item.bigPrice.sgst,
    smallUnitCount: 0,
    chooseUnit: 5 /* SELECTEDBIGPRICE */,
    remQuan: item.remQuan[0],
    totalQuan: item.remQuan[0],
    cgstAmt: item.custGstDisabled ? 0.0 : item.bigPrice.cgstAmt,
    sgstAmt: item.custGstDisabled ? 0.0 : item.bigPrice.sgstAmt,
    appliedOfferAmt: appliedOfferAmt,
    isOutOfStock: item.isOutOfStock ?? false,

    initialOrder: {
      subTotalPrice: price,
      finalPrice: finalSp,
      cgstAmt: item.custGstDisabled ? 0.0 : item.bigPrice.cgstAmt,
      sgstAmt: item.custGstDisabled ? 0.0 : item.bigPrice.sgstAmt,
      appliedOfferAmt: appliedOfferAmt
    },
  };
};

const buildExistItem = (item, mQuantity) => {
  const mapStockRefNo = new Map(Object.entries(item.stockRefNo));
  mapStockRefNo.set(item.lastStockRefNo, item.unit + "=" + mQuantity);
  const parsedCgstAmt = Number(item.initialOrder.cgstAmt) * mQuantity;
  const parsedSgstAmt = Number(item.initialOrder.sgstAmt) * mQuantity;
  const subTotalPrice = Number(item.initialOrder.subTotalPrice) * mQuantity;
  const finalPrice = Number(item.initialOrder.finalPrice) * mQuantity;
  const parsedAppliedOfferAmt = Number(item.initialOrder.appliedOfferAmt) * mQuantity;

  const newObj = { ...item };
  newObj.quantity = mQuantity;
  newObj.stockRefNo = Object.fromEntries(mapStockRefNo);
  newObj.cgstAmt = parsedCgstAmt;
  newObj.sgstAmt = parsedSgstAmt;
  newObj.subTotalPrice = subTotalPrice;
  newObj.finalPrice = finalPrice;
  newObj.appliedOfferAmt = parsedAppliedOfferAmt;
  return newObj;
}

const addReqOnExistItem = (item, productDispatch, isAdd, orderState, orderDispatch) => {
  printDebugLog("addOnExistItem init", item);
  const mQuantity = item.quantity + 1;
  if (mQuantity <= item.remQuan) {
    const nItem = buildExistItem(item, mQuantity);
    printDebugLog("addOnExistItem end", nItem);
    productDispatch({ type: "setCart", payload: nItem });
    doTotal(nItem, item, isAdd, orderState, orderDispatch);
  } else {
    toast.error(`Cannot add more than ${item.remQuan} pack.`, 3000)
  }
};

const permanentRemovedFromCart = (item, productDispatch, orderState, orderDispatch) => {
  printDebugLog("permanentRemovedFromCart init", item);
  productDispatch({ type: "setRemoveCartIds", payload: item.prdId });
  productDispatch({ type: "setRemoveCart", payload: item });
  doTotal(null, item, false, orderState, orderDispatch);
};

const removeReqOnExistItem = (item, productDispatch, isAdd, orderState, orderDispatch) => {
  printDebugLog("removeReqOnExistItem init", item);
  const mQuantity = item.quantity - 1;
  if (mQuantity > 0) {
    const nItem = buildExistItem(item, mQuantity);
    printDebugLog("removeReqOnExistItem end", nItem);
    productDispatch({ type: "setCart", payload: nItem });
    doTotal(nItem, item, isAdd, orderState, orderDispatch);
  } else {
    permanentRemovedFromCart(item, productDispatch, orderState, orderDispatch);
  }
}

const decideOnItem = (item, cartOperation, productDispatch, orderState, orderDispatch, carts = []) => {
  const foundItem = carts.length > 0 ? carts.find(cItem => cItem.prdId === item.prdId) : undefined;
  printDebugLog("decideOnItem", carts, item, foundItem, cartOperation);
  if (cartOperation === CartOperation.add) {
    if (foundItem) {
      addReqOnExistItem(foundItem, productDispatch, true, orderState, orderDispatch);
    } else {
      const nItem = buildCartItem(item, carts);
      printDebugLog("decideOnItem", nItem);
      productDispatch({ type: "setCartIds", payload: item.prdId });
      productDispatch({ type: "setCart", payload: nItem });
      doTotal(nItem, null, true, orderState, orderDispatch);
    }
  } else if (cartOperation === CartOperation.remove) {
    if (foundItem) {
      removeReqOnExistItem(foundItem, productDispatch, false, orderState, orderDispatch);
    } else {
      printDebugLog("decideOnItem Ignoring because already removed its just fast click");
    }
  } else {
    permanentRemovedFromCart(foundItem, productDispatch, orderState, orderDispatch);
  }
}

const updateCartItems = async (cartIds = [], carts = [], mobile, setLoader, productDispatch, orderDispatch) => {
  printDebugLog("updateCartItems", cartIds, carts, mobile);
  if (carts.length === 0 && cartIds.length > 0 && !isEmpty(mobile)) {
    setLoader(true);
    const cartListDataResponse = await getCartProducts(mobile);
    if (cartListDataResponse !== null && cartListDataResponse.length > 0 && Array.isArray(cartListDataResponse)) {
      const newCarts = [];
      let parseSubTotal = 0.0;
      let parseTotalQuantity = 0.0;
      let parseCgstAmt = 0.0;
      let parsedSgstAmt = 0.0;
      let parseTotalOfferApplied = 0.0;
      let parseBeforeCouponTotal = 0.0;
      cartListDataResponse.forEach(item => {
        const parsedItem = buildCartItem(item, newCarts);
        printDebugLog("updateCartItems parsedItem", parsedItem);
        parseSubTotal += Number(parsedItem.subTotalPrice);
        parseTotalQuantity += Number(parsedItem.quantity);
        parseCgstAmt += Number(parsedItem.cgstAmt);
        parsedSgstAmt += Number(parsedItem.sgstAmt);
        parseTotalOfferApplied += Number(parsedItem.appliedOfferAmt);
        parseBeforeCouponTotal += Number(parsedItem.finalPrice);
        newCarts.push(parsedItem);
      });
      printDebugLog("updateCartItems newCarts", newCarts);
      productDispatch({ type: "setCart", payload: newCarts });
      const mRoundOff = parseBeforeCouponTotal.toFixed() - parseBeforeCouponTotal;
      const mainGrandTotal = parseBeforeCouponTotal + mRoundOff;
      const orderObject = {
        totalQuantity: parseTotalQuantity,
        subTotal: parseSubTotal,
        cgstAmt: parseCgstAmt,
        sgstAmt: parsedSgstAmt,
        totalOfferApplied: parseTotalOfferApplied,
        totalBeforeOffer: parseBeforeCouponTotal,
        total: mainGrandTotal,
        orderAddress: "",
        offerDenom: OfferType.No_Offer,
        offerAmt: 0.0,
        coupon: "",
        roundOff: mRoundOff,
        isGstAllowed: true,
        deliveryCharge: 0,
      };
      orderDispatch({ type: "setOrderDetails", payload: orderObject });
    }
    setLoader(false);
  }
}

const addRemoveProductToCart = async (
  item,
  productDispatch,
  userMobile,
  cartOperation,
  cartBtnDisabled,
  carts = [],
  orderState,
  orderDispatch
) => {
  cartBtnDisabled(true);
  printDebugLog("addRemoveProductToCart", item)
  try {
    const data = {
      jcJson: {
        shopHash: encode(WEBSITE_SHOP_HASH),
        inventoryId: item.prdId,
        type: Server_Constants.IN_CART,
        custMob: userMobile,
        isAdd: cartOperation === CartOperation.add ? true : false,
      },
    };
    const payLoad = await POST("ext/cart/update-product-state-info", data);
    if (payLoad !== null) {
      decideOnItem(item, cartOperation, productDispatch, orderState, orderDispatch, carts);
      toast.success(`Item is ${cartOperation === CartOperation.add ? "added to" : "removed from"} Cart!`);
    }
  } catch (err) {
    console.error("addProductToCart: ", err);
  } finally {
    cartBtnDisabled(false);
  }
};

const getCartProducts = async (userMobile) => {
  try {
    const encodedShopHash = encode(WEBSITE_SHOP_HASH);
    const payLoad = await GET(`ext/cart/get-product-state?shopHash=${encodedShopHash}&custMob=${userMobile}&type=${Server_Constants.IN_CART}`);
    if (payLoad !== null) {
      return payLoad?.fullData ?? [];
    } else {
      console.error("getCartProducts", "null payload");
      return [];
    }
  } catch (err) {
    console.error("getCartProducts", err);
    return [];
  }
};

const getSingleProductStockInformation = async (setIsLoading, inventoryId) => {
  try {
    setIsLoading?.(true);
    const encodedShopHash = encode(WEBSITE_SHOP_HASH);
    const payLoad = await GET(`ext/cart/single-product-stock-information?shopHash=${encodedShopHash}&inventoryId=${inventoryId}`);
    if (payLoad !== null) {
      return payLoad?.inventory ?? null;
    } else {
      console.error("getSingleProductStockInformation", "null payload");
      return null;
    }
  } catch (err) {
    console.error("getSingleProductStockInformation", err);
    return null;
  } finally {
    setIsLoading?.(false);
  }
};

const handleProductQunatityInCart = (
  item, isAdd, productDispatch, orderState, orderDispatch, carts = [],
  setBtnDisabled
) => {
  setBtnDisabled(true);
  try {
    const cartOperation = isAdd ? CartOperation.add : CartOperation.remove;
    decideOnItem(item, cartOperation, productDispatch, orderState, orderDispatch, carts)
  } catch (err) {
    console.error("handleProductQunatityInCart", err);
  } finally {
    setBtnDisabled(false);
  }
};

//Change to batch in Server
const clearCart = async (productDispatch, cart, userMobile) => {
  try {
    for (const item of cart) {
      try {
        const data = {
          jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
            inventoryId: item._id,
            type: Server_Constants.IN_CART,
            custMob: userMobile,
            isAdd: false,
          },
        };
        const payLoad = await POST("ext/cart/update-product-state-info", data);
        if (payLoad !== null) {
          printDebugLog("Item removed from cart:", item._id);
        }
      } catch (err) {
        console.error("addProductToCart: ", err);
      }
    }
    productDispatch({ type: "setCartReset" });
    toast.success("All items removed from cart!");
  } catch (error) {
    console.error("Error in clear cart", error);
  }
};

//name, mobileNum, addressType, landMark, address, city, state, country, zipCode
const handleAddressChange = (e, orderDispatch, addresses) => {
  const id = e.target.value;
  const addr = addresses.find(a => a.id === id) || null;
  if (addr) {
    orderDispatch({ type: "setDesAddress", payload: getAddressUtils(addr) });
  } else {
    orderDispatch({ type: "setDesAddress", payload: "" });
  }
};


const buildOrderDetails = (orderState, productState, mobile) => {
  return {
    shopHash: encode(WEBSITE_SHOP_HASH),
    custMob: mobile,
    list: productState?.cart,
    destinationAddress: orderState?.destinationAddress,
    roundOff: orderState.roundOff,
    subTotal: orderState.subTotal,
    total: orderState.total,
    totalOfferApplied: orderState.totalOfferApplied,
    offerDenom: orderState.offerDenom,
    offerAmt: orderState.offerAmt,
    cgstAmt: orderState.cgstAmt,
    sgstAmt: orderState.sgstAmt,
    totalBeforeOffer: orderState.totalBeforeOffer,
    totalQuantity: orderState.totalQuantity,
    deliveryCharge: orderState.deliveryCharge,
    coupon: orderState.coupon,
  }
};

export {
  isProductInCart,
  addRemoveProductToCart,
  getCartProducts,
  handleProductQunatityInCart,
  clearCart,
  updateCartItems,
  handleAddressChange,
  buildOrderDetails,
  updateTotalBasedOnCoupon,
  getSingleProductStockInformation
};
